import { useContext } from 'react';
import { useSelector } from 'react-redux';
import t from 'react-translate';
import { getMentoringProgramAliases } from 'redux/selectors/mentoring-programs';
import { GuidanceSubTab } from 'athena/components/mentoring-program/guidance';
import MentoringProgramContext from '../../context';

const ActionItemsInfo = () => {
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { mentorAlias, menteeAlias } = useSelector((state) => (
    getMentoringProgramAliases(state, mentoringProgram?.id)
  ));
  const guidanceTabLink = `/#!/mentoring-programs/${mentoringProgram?.id}/guidance?tab=${GuidanceSubTab.ACTION_ITEMS}`;
  const translationBase = t.MENTORING_PROGRAMS.SETTINGS.TABS.GUIDANCE.ACTION_ITEMS;

  return (
    <div className='mt-4'>
      <div className='heading-5 mb-2'>{translationBase.TITLE()}</div>
      <div className='text-body black mb-4'>
        {translationBase.DESCRIPTION({ guidanceTabLink, mentorAlias, menteeAlias })}
      </div>
    </div>
  );
};

export default ActionItemsInfo;
